import "./App.scss";
import DesktopMenu from "./components/desktop-menu/desktop-menu";
import Hero from "./components/hero/hero";
import CopyRight from "./components/copy-right/copy-right";

function App() {
  return (
    <>
      <DesktopMenu />
      <Hero />
      <CopyRight />
    </>
  );
}

export default App;
